import { CdkDrag } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { IconModule } from '@shared/icon/icon.module';
import { BrowserCallService } from '@app/modules/crm/services/browser-call.service';
import type { BrowserCallState } from '@app/modules/crm/services/browser-call.types';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-browser-call-controls',
	standalone: true,
	imports: [CommonModule, IconModule, CdkDrag],
	templateUrl: './browser-call-controls.component.html',
})
export class BrowserCallControlsComponent implements OnInit, OnDestroy {
	private readonly browserCallService = inject(BrowserCallService);
	private callStateSubscription?: Subscription;

	callState: BrowserCallState = { status: 'idle' };
	isMinimized = false;

	ngOnInit(): void {
		this.callStateSubscription = this.browserCallService.callState$.subscribe((state) => {
			this.callState = state;
		});
	}

	ngOnDestroy(): void {
		this.callStateSubscription?.unsubscribe();
	}

	toggleMute(): void {
		this.browserCallService.toggleMute();
	}

	toggleHold(): void {
		this.browserCallService.toggleHold();
	}

	hangup(): void {
		void this.browserCallService.hangup();
	}

	acceptIncoming(): void {
		void this.browserCallService.acceptIncomingCall();
	}

	declineIncoming(): void {
		this.browserCallService.rejectIncomingCall();
	}

	isInboundRinging(): boolean {
		return this.callState.isInbound === true && this.callState.status === 'ringing';
	}

	formatDuration(seconds?: number): string {
		if (!seconds) {
			return '00:00';
		}
		return this.browserCallService.formatDuration(seconds);
	}

	getStatusLabel(): string {
		switch (this.callState.status) {
			case 'connecting':
				return 'Connecting...';
			case 'ringing':
				return this.callState.isInbound ? 'Incoming call...' : 'Ringing...';
			case 'connected':
				return this.callState.isOnHold ? 'On hold' : 'Connected';
			case 'disconnected':
				return 'Call Ended';
			case 'error':
				return 'Call Error';
			default:
				return 'Idle';
		}
	}

	isCallActive(): boolean {
		return ['connecting', 'ringing', 'connected'].includes(this.callState.status);
	}

	isCallConnected(): boolean {
		return this.callState.status === 'connected';
	}

	showHoldButton(): boolean {
		return false;
	}

	toggleMinimize(): void {
		this.isMinimized = !this.isMinimized;
	}
}
